<template>
  <div>
    <el-row class="totalTable">
      <el-col :span="24" class="titleView">
        <el-row>
          <el-col :offset="1" :span="2" class="rainbowLogo">
            <img src="@/assets/images/logoIcon.png" />
          </el-col>
          <el-col :span="21" class="userMessage">您的基本信息</el-col>
          <el-col :span="21" class="msgDesc"
            >完善基本信息后会遇到更多对你感兴趣的招聘者</el-col
          >
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      disX: 0,
      rangeStatus: false,
    };
  },
  methods: {},
};
</script>

<style lang="stylus" scoped>
.totalTable {
  margin-top: 50px;
}

.titleView {
  width: 860px;
  height: 100px;
  background: #080723;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 14px 14px 0 0;
}

.rainbowLogo img {
  margin-top: 24px;
}

.changeBoss {
  // width: 96px;
  height: 16px;
  font-size: 16px;
  font-weight: 400;
  color: #f82b17;
  line-height: 44px;
  text-align: left;
}

.rightButton {
  width: 120px;
  height: 44px;
  background: #f82b17;
  border-radius: 6px;
  line-height: 44px;
  color: rgba(255, 255, 255, 1);
}

.userMessage {
  width: 120px;
  height: 20px;
  font-size: 20px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 30px;
  margin-top: 24px;
  margin-left: 15px;
}

.msgDesc {
  width: 80%;
  height: 16px;
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 24px;
  text-align: left;
  margin-top: 10px;
  margin-left: 15px;
}
</style>